import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UserService } from 'src/app/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { NgxSpinnerService } from "ngx-spinner";
import { ThemeService } from 'ng2-charts';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.css']
})
export class UploadDocumentComponent implements OnInit {

  fileToUpload: File = null;
  public selectedType: any;
  fileUploadService: any;
  public website: any;
  // @@@@@@@@@@@@@@
  fileData: File;

  // @@@@@@@@@@@@@

  form = new FormGroup({
    website: new FormControl('', Validators.required),
    chooseFile: new FormControl('', Validators.required)
  });
  fileType: string | Blob;
  ramki: any;
  sri: any;
  abc: any;
  id: any;
  name: any;

  get f() {
    return this.form.controls;
  }

  constructor(public usr: UserService,
    public toastr: ToastrService,
    public router: Router,
    private SpinnerService: NgxSpinnerService) {
    let b = JSON.parse(localStorage.getItem('data'));
    this.ramki = b;
  }

  ngOnInit(): void {
    this.usr.type().subscribe((res: any) => {
      if (res.code === 200) {
        this.sri = res.data;
      }
    });

    this.form.valueChanges.subscribe((value) => {
      this.id = value.website.split('||');
    });
  }

  fileProgress(files: any) {
    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('user_id', this.ramki.user_id);
    formData.append('type', this.id[0]);
    formData.append('fileCategory', this.id[1]);
  
    let temp_fileData = <File>files.target.files[0];
    if (temp_fileData.type === 'text/html') {
      this.fileData = null;
      this.toastr.error("not accepeted");
    } else {
      this.fileData = <File>files.target.files[0];
      // this.toastr.success("Upload Successful");
    }
    // else if (temp_fileData.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
    //   this.fileData = <File>files.target.files[0];
    //   console.log(this.fileData);
    // } else if (temp_fileData.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    //   this.fileData = <File>files.target.files[0];
    //   console.log(this.fileData);
    // } else if (temp_fileData.type === 'application/vnd.ms-excel') {
    //   this.fileData = <File>files.target.files[0];
    //   console.log(this.fileData);
    // } else {
    //   return this.toastr.error("Files Only");
    // }
  }

  submit() {
    let a = JSON.parse(localStorage.getItem("data"));
    this.name = a.firstName + a.lastName;
    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('user_id', this.ramki.user_id);
    formData.append('type', this.id[0]);
    formData.append('fileCategory', this.id[1]);
    formData.append('name', this.name);
    this.SpinnerService.show();
    this.usr.file(formData).subscribe((res: any) => {
      if (res.code === 200) {
        this.SpinnerService.hide();
        this.toastr.success("Uploaded Successfully");  
        setTimeout(() => {
          this.router.navigate(['documents']);
        }, 1000);

      } else if (res.code === 400) {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        this.fileData = null;
      } else {
        this.SpinnerService.hide();
        this.toastr.error(res.message);
        this.fileData = null;
      }
    },
      (err) => {
        this.SpinnerService.hide();
        return this.toastr.error(err.message);
      });
  }
}